
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockItemsGrid extends Serenity.EntityGrid<OpeningStockItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.OpeningStockItems'; }
        protected getDialogType() { return OpeningStockItemsDialog; }
        protected getIdProperty() { return OpeningStockItemsRow.idProperty; }
        protected getInsertPermission() { return OpeningStockItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return OpeningStockItemsRow.localTextPrefix; }
        protected getService() { return OpeningStockItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        //protected getSlickOptions() {
        //    let opt = super.getSlickOptions();
        //    opt.editable = true;
        //    opt.autoEdit = true;
        //    //opt.forceFitColumns = true;
        //    return opt;
        //}
        
    }
}